import { enableProdMode, provideZoneChangeDetection } from '@angular/core';

import { environment } from '@selftest/env/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (environment.production) {
	enableProdMode();
}

bootstrapApplication(AppComponent, {
	...appConfig,
	providers: [provideZoneChangeDetection(), ...appConfig.providers],
}).catch((err) => console.error(err));
